<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-truck"
      texto-titulo="Nuevo reparto"
    ></TituloComponent>
    <form @submit.prevent="guardarReparto()">
      <div class="main-card mb-3 card col-12">
        <div class="card-body">
          <div class="row">
            <div class="widget-wrapper col-lg-6">
              <div class="widget-heading opacity-10">
                <float-label label="Repartidor" clase="w-100 mb-md-0">
                  <select
                    name="repartidor_id"
                    id="repartidor_id"
                    class="form-control"
                    v-model="repartidor_id"
                  >
                    <option :value="null">Seleccione repartidor</option>
                    <option
                      v-for="repartidor in repartidores"
                      :key="repartidor.id"
                      :value="repartidor.id"
                    >
                      {{ repartidor.nombre }}
                    </option>
                  </select>
                </float-label>
              </div>
            </div>
            <div class="widget-wrapper col-lg-6">
              <div class="widget-heading opacity-10">
                <float-label label="Fecha" clase="w-100 mb-md-0">
                  <input
                    type="date"
                    id="fecha"
                    class="form-control"
                    v-model="fecha"
                  />
                </float-label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-outline-primary mb-3 card">
        <div class="card-header">
          <i
            class="fas fa-filepowerpoint header-icon icon-gradient bg-success"
          ></i>
          Comprobantes
        </div>
        <div class="card-body p-0">
          <ul
            class="list-group list-group-flush mb-3"
            v-if="comprobantes.length > 0"
          >
            <li
              class="list-group-item hoverable"
              v-for="(comprobante, i) in comprobantes"
              :key="i"
              @click="clickComprobante(comprobante, i)"
            >
              <div class="widget-content p-0">
                <div class="widget-content-wrapper row">
                  <div class="widget-content-left col-12">
                    <h5 class="widget-heading">
                      <span class="text-alternate">
                        {{ comprobante.denominacion }} -
                      </span>
                      <span class="text-success">
                        {{ comprobante.total | numFormat("0,0.00") }}
                      </span>
                    </h5>
                    <div class="widget-subheading opacity-10 row">
                      <span class="col-sm-auto col-12">
                        Cliente:
                        <b class="text-info">
                          {{ comprobante.cliente.nombre }}
                        </b>
                      </span>
                      <span class="col-sm-auto col-12">
                        Forma de pago:
                        <b class=""> {{ comprobante.forma_pago }} </b>
                      </span>
                      <span class="col-sm-auto col-12">
                        Fecha:
                        <b class="">{{
                          comprobante.created_at | moment("DD/MM/YYYY")
                        }}</b>
                      </span>
                      <span class="col-sm-auto col-12">
                        Vendedor:
                        <b class="">{{ comprobante.user.nombre }}</b></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="grid-menu grid-menu-2col">
            <div class="no-gutters row">
              <div class="col-12">
                <button
                  type="button"
                  class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                  @click="abrirListarComprobantes = true"
                >
                  <i class="fas fa-plus btn-icon-wrapper btn-icon-lg mb-3"></i
                  >Añadir comprobante
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="mt-1 btn btn-info float-right">Guardar</button>
    </form>

    <ModalListarComprobantes
      v-if="abrirListarComprobantes"
      :used-ids="comprobantes.map((comprobante) => comprobante.id)"
      @selectComprobante="selectComprobante"
      @cerrarListarComprobantes="abrirListarComprobantes = false"
    />
  </div>
</template>

<script>
import TituloComponent from "@/components/layouts/TituloComponent.vue";
import BlockUI from "@/components/loaders/BlockUI.vue";
import FloatLabel from "@/components/layouts/FloatLabel.vue";
import axios from "axios";
import moment from "moment/moment";
import ModalListarComprobantes from "@/components/views/repartos/ModalListarComprobantes.vue";
import Swal from "sweetalert2";

export default {
  name: "CrearReparto",
  components: { ModalListarComprobantes, FloatLabel, BlockUI, TituloComponent },
  data() {
    return {
      loading: false,
      repartidores: [],
      abrirListarComprobantes: false,
      comprobantes: [],
      repartidor_id: null,
      fecha: null,
    };
  },
  mounted() {
    this.fecha = moment().format("Y-MM-DD");
    this.getRepartidores();
  },
  methods: {
    getRepartidores() {
      this.loading = true;
      axios.get("/repartidores").then((res) => {
        for (let repartidor of res.data.data) {
          this.repartidores.push(repartidor);
        }
        this.loading = false;
      });
    },
    guardarReparto() {
      this.loading = true;
      if (this.repartidor_id == null) {
        Swal.fire("Oops!", "Debe seleccionar un repartidor", "warning");
        this.loading = false;
        return false;
      }

      if (this.comprobantes.length === 0) {
        Swal.fire("Oops!", "Debe agregar algún comprobante", "warning");
        this.loading = false;
        return false;
      }

      const data = {
        fecha: this.fecha,
        repartidor: this.repartidor_id,
        movimientos: this.comprobantes.map((comprobante) => comprobante.id),
      };
      axios
        .post("/reparto", data)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: `El reparto se guardó con éxito.`,
          });
          this.$router.push({ name: "ListarRepartos" });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectComprobante(comprobante) {
      const exists = this.comprobantes.some(
        (existing) => existing.id === comprobante.id,
      );
      if (!exists) {
        this.comprobantes.push(comprobante);
      }
    },
    clickComprobante(comprobante) {
      Swal.fire({
        title: "¿Seguro desea eliminar?",
        text: comprobante.denominacion,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.comprobantes = this.comprobantes.filter(
            (comp) => comp.id !== comprobante.id,
          );
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire(
            "Eliminado!",
            "Se eliminó " + comprobante.denominacion,
            "success",
          );
        }
      });
    },
  },
};
</script>

<style scoped></style>
